module.exports = __webpack_public_path__ + "static/media/bgTopPostByMonth.1a151501.svg";